import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export default function PasswordChangedSuccessfully() {
  const navigate = useNavigate();

  return (
    <>
      {/* ========== MAIN CONTENT ========== */}
      <main id="content" role="main" className="main">
        <div
          className="position-fixed top-0 end-0 start-0 bg-img-start"
          style={{ height: "32rem", backgroundImage: "url(/static/svg/components/card-6.svg)" }}
        >
          {/* Shape */}
          <div className="shape shape-bottom zi-1">
            <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 1921 273">
              <polygon fill="#fff" points="0,273 1921,273 1921,0 " />
            </svg>
          </div>
          {/* End Shape */}
        </div>
        {/* Content */}
        <div className="container py-5 py-sm-7">
          <a className="d-flex justify-content-center mb-5" href="/">
            <img className="zi-2" src="/logo.svg" alt="Image Description" style={{ maxHeight: "3rem" }} />
          </a>
          <div className="mx-auto" style={{ maxWidth: "30rem" }}>
            {/* Card */}
            <div className="card card-lg mb-5">
              <div className="card-body text-center">
                <h1 className="display-5">
                  Password Changed <br /> Successfully
                </h1>
                <p className="mb-1">We've updated your password</p>

                <div className="mt-4 mb-3">
                  <a className="btn btn-primary" href="/login">
                    Login
                  </a>
                </div>
              </div>
            </div>
            {/* End Card */}
          </div>
        </div>
        {/* End Content */}
      </main>
      {/* ========== END MAIN CONTENT ========== */}
    </>
  );
}
